<template>
    <div class="flex h-auto bg-gray-900 text-white">
        <!-- Sidebar -->
        <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
            <div class="flex items-center justify-center space-x-3">
                <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
            </div>
            <Navbar></Navbar>
        </aside>

        <!-- Main Content -->
        <div class="flex-1 flex flex-col">
            <!-- Top Navbar -->
            <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
                <h2 class="text-xl font-semibold">Support</h2>
                <!-- Toggle Button -->
                <button 
                    @click="toggleStatus"
                    class="px-4 py-2 rounded-lg shadow-md transition-colors duration-200"
                    :class="ticket.status === 'Open' ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'">
                    {{ ticket.status === 'Open' ? 'Close Ticket' : 'Reopen Ticket' }}
                </button>
            </header>

            <!-- View Ticket Page -->
            <main class="p-6 flex-1">
                <div class="bg-gray-800 p-6 rounded-xl shadow-md flex flex-col h-full">
                    <h3 class="text-lg font-semibold mb-4">Ticket #{{ ticket.id }}</h3>
                    <div class="p-4 bg-gray-700 rounded-lg shadow-inner">
                        <p class="text-gray-300 mb-2"><strong>Issue:</strong> {{ ticket.subject }}</p>
                        <p class="text-gray-300"><strong>Status:</strong> {{ ticket.status }}</p>
                    </div>

                    <!-- Ticket Messages -->
                    <div class="mt-6 flex-1 overflow-y-auto space-y-4 p-4 bg-gray-700 rounded-lg">
                        <div v-if="messages.length === 0" class="text-gray-300">No messages yet.</div>
                        <div v-for="message in messages" :key="message.id" class="p-4 rounded-lg shadow-md"
                            :class="message.sender === 'support' ? 'bg-blue-500 self-start' : 'bg-gray-500 self-end'">
                            <p class="font-semibold">{{ message.sender === 'support' ? 'Support' : 'You' }}</p>
                            <p>{{ message.text }}</p>
                            <p class="text-xs text-gray-300 mt-1">{{ formatTimestamp(message.timestamp) }}</p>
                        </div>
                    </div>

                    <!-- Reply Box -->
                    <div class="mt-4 p-4 bg-gray-700 rounded-lg shadow-md" v-if="ticket.status === 'Open'">
                        <label for="reply" class="block text-gray-300 mb-2">Reply</label>
                        <textarea v-model="newMessage" id="reply" class="w-full p-2 bg-gray-800 rounded-lg text-white"
                            placeholder="Type your reply..."></textarea>
                        <button @click="sendMessage" class="mt-2 px-4 py-2 bg-blue-500 rounded-lg hover:bg-blue-600">Send</button>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import Navbar from '@/components/adminnav.vue';
import axios from 'axios';

export default {
    name: "CloudSupportTicket",
    components: { Navbar },
    data() {
        return {
            ticket: {},
            messages: [],
            newMessage: ""
        };
    },
    async created() {
        await this.fetchTicket();
        await this.fetchMessages();
    },
    methods: {
        async fetchTicket() {
            try {
                const response = await axios.get(`https://api.syniac.com:3000/api/ticket/${this.$route.params.id}`, { withCredentials: true });
                this.ticket = response.data;
            } catch (error) {
                console.error("Error fetching ticket:", error);
            }
        },
        async fetchMessages() {
            try {
                const response = await axios.get(`https://api.syniac.com:3000/api/ticket/${this.$route.params.id}/messages`, { withCredentials: true });
                this.messages = response.data;
            } catch (error) {
                console.error("Error fetching messages:", error);
            }
        },
        async sendMessage() {
            if (!this.newMessage.trim()) return;

            try {
                await axios.post(`https://api.syniac.com:3000/api/ticket/${this.ticket.id}/messages`, 
                { text: this.newMessage, sender: "support" }, 
                { withCredentials: true });

                this.messages.push({
                    id: this.messages.length + 1,
                    sender: 'support',
                    text: this.newMessage,
                    timestamp: new Date().toISOString()
                });

                this.newMessage = "";
            } catch (error) {
                console.error("Error sending message:", error);
            }
        },
        async toggleStatus() {
            try {
                const newStatus = this.ticket.status === "Open" ? "Closed" : "Open";
                await axios.put(
                    `https://api.syniac.com:3000/api/admin/ticket/${this.ticket.id}/status`,
                    { status: newStatus },
                    { withCredentials: true }
                );
                this.ticket.status = newStatus;
            } catch (error) {
                console.error("Error updating ticket status:", error);
            }
        },
        formatTimestamp(timestamp) {
            return new Date(timestamp).toLocaleString();
        }
    }
};
</script>
